module.exports = __webpack_public_path__ + "static/media/dinesh.eb5bc576.png";